import { render, staticRenderFns } from "./ModalIconsForm.vue?vue&type=template&id=6b5a359e&scoped=true&"
import script from "./ModalIconsForm.vue?vue&type=script&lang=js&"
export * from "./ModalIconsForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalIconsForm.vue?vue&type=style&index=0&id=6b5a359e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a359e",
  null
  
)

export default component.exports